import { API_GET_DICTIONARY_RAYON_FOR_OBL, MAIN_URL, PORT } from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

const regNum = {
  key: "regNum",
  label: "Регистрационный номер судна",
  type: "text",
  placeholder: "В формате XX1111",
};
const unp = {
  key: "unp",
  label: "УНП",
  type: "text",
  placeholder: "Введите",
};
const nameLe = {
  key: "nameLe",
  label: "Наименование организации",
  type: "text",
  placeholder: "Введите",
};
const section = {
  key: "section",
  label: "Участок",
  type: "selectWithSearch",
  placeholder: "Выберите",
  isSearchable: true,
  options: [{ value: 0, label: "Все", key: "section" }],
};
const status = {
  key: "status",
  label: "Статус заявления",
  type: "selectWithSearch",
  placeholder: "Выберите",
  isSearchable: false,
};
const appNum = {
  key: "appNum",
  label: "Регистрационный номер заявления",
  type: "text",
  placeholder: "Введите",
};

const commonInputs = {
  surname: {
    key: "surname",
    label: "Фамилия",
    type: "text",
    placeholder: "Введите",
  },
  name: {
    key: "name",
    label: "Имя",
    type: "text",
    placeholder: "Введите",
  },
  midname: {
    key: "midname",
    label: "Отчество",
    type: "text",
    placeholder: "Введите",
  },
};

export const options = {
  inputsSmallBoats: {
    key: "inputsSmallBoats",
    caption: "Судовая книга",
    inputsOptions: {
      ownerSurname: {
        key: "ownerSurname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      ownerName: {
        key: "ownerName",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      ownerMidname: {
        key: "ownerMidname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      regNum: {
        key: "regNum",
        label: "Рег. номер судна",
        type: "text",
        placeholder: "В формате XX1111",
      },
      leName: {
        key: "leName",
        label: "Наим. организации",
        type: "text",
        placeholder: "Введите",
      },
      leUnp: {
        key: "leUnp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      engvin: {
        key: "engvin",
        label: "Заводской номер двигателя",
        type: "text",
        placeholder: "Введите",
      },
      boatVin: {
        key: "boatVin",
        label: "Заводской номер судна",
        type: "text",
        placeholder: "Цифры и латиница",
      },
      cardStatusCode: {
        key: "cardStatusCode",
        label: "Статус карточки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 1, label: "Активная", key: "cardStatusCode" },
          { value: 0, label: "Архивная", key: "cardStatusCode" },
          { value: 2, label: "Историческая", key: "cardStatusCode" },
          { value: 3, label: "Все", key: "cardStatusCode" },
        ],
      },
    },
  },
  inputsCertificates: {
    key: "inputsCertificates",
    caption: "Учет выдачи удостоверений на право управления моторными маломерными и прогулочными судами",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      licenseNum: {
        key: "licenseNum",
        label: "Номер удостоверения",
        type: "text",
        placeholder: "Введите",
      },
      persNum: {
        key: "persNum",
        label: "Идентификационный номер",
        type: "text",
        placeholder: "В формате 1111111X111XX1",
      },
      cardStatusCode: {
        key: "cardStatusCode",
        label: "Статус карточки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Архивная", key: "cardStatusCode" },
          { value: 1, label: "Активная", key: "cardStatusCode" },
          { value: 2, label: "Историческая", key: "cardStatusCode" },
          { value: 3, label: "Все", key: "cardStatusCode" },
        ],
      },
      licenseType: {
        key: "licenseType",
        label: "Тип удостоверения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "licenseType" },
          { value: 1, label: "Республиканское", key: "licenseType" },
          { value: 2, label: "Международное", key: "licenseType" },
        ],
      },
    },
  },
  inputsBasesBuildings: {
    key: "inputsBasesBuildings",
    caption: "Реестр баз (сооружений) для стоянок маломерных судов",
    inputsOptions: {
      ownerCommonName: {
        key: "ownerCommonName",
        label: "Наименование ЮЛ, ФИО эксплуатанта",
        type: "text",
        placeholder: "Введите",
      },
      ownerUnp: {
        key: "ownerUnp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      location: {
        key: "location",
        label: "Местонахождение базы",
        type: "text",
        placeholder: "Введите",
      },
      startDate: {
        key: "startDate",
        label: "Дата последнего обследования от",
        type: "date",
      },
      endDate: {
        key: "endDate",
        label: "Дата последнего обследования до",
        type: "date",
      },
      checkStatus: {
        key: "checkStatus",
        label: "Результат обследования",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [{ value: 0, label: "Все", key: "checkStatus" }],
      },
    },
  },
  inputsIssuingCertificates: {
    key: "inputsIssuingCertificates",
    caption: "Выдача удостоверений",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [{ value: 0, label: "Все", key: "status" }],
      },
      licenseType: {
        key: "licenseType",
        label: "Тип удостоверения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "licenseType" },
          { value: 1, label: "Республиканское", key: "licenseType" },
          { value: 2, label: "Международное", key: "licenseType" },
        ],
      },
    },
  },
  inputsPrintCertificates: {
    key: "inputsPrintCertificates",
    caption: "Печать удостоверений",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      apptype: {
        key: "apptype",
        label: "Административная процедура",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "apptype" },
          { value: 1, label: "Выдача", key: "apptype" },
          { value: 2, label: "Дубликат", key: "apptype" },
          { value: 3, label: "Обмен", key: "apptype" },
        ],
      },
      appDate: {
        key: "appDate",
        label: "Дата рег.заявления",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [{ value: 0, label: "Все", key: "status" }],
      },
      licenseType: {
        key: "licenseType",
        label: "Тип удостоверения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "licenseType" },
          { value: 1, label: "Республиканское", key: "licenseType" },
          { value: 2, label: "Международное", key: "licenseType" },
        ],
      },
    },
  },
  inputsExchangeCertificates: {
    key: "inputsExchangeCertificates",
    caption: "Обмен удостоверений",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: 0, label: "Все", key: "status" }],
      },
      licenseNum: {
        key: "licenseNum",
        label: "Номер удостоверения",
        type: "text",
        placeholder: "Введите",
      },
      licenseDate: {
        key: "licenseDate",
        label: "Дата удостоверения",
        type: "date",
        placeholder: "Введите",
      },
      licenseType: {
        key: "licenseType",
        label: "Тип удостоверения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 0, label: "Все", key: "licenseType" },
          { value: 1, label: "Республиканское", key: "licenseType" },
          { value: 2, label: "Международное", key: "licenseType" },
        ],
      },
    },
  },
  inputsDuplicateCertificates: {
    key: "inputsDuplicateCertificates",
    caption: "Выдача дубликата удостоверения",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
        placeholder: "Введите",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: 0, label: "Все", key: "status" }],
      },
      licenseNum: {
        key: "licenseNum",
        label: "Номер удостоверения",
        type: "text",
        placeholder: "Введите",
      },
      licenseDate: {
        key: "licenseDate",
        label: "Дата удостоверения",
        type: "date",
      },
      licenseType: {
        key: "licenseType",
        label: "Тип удостоверения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 0, label: "Все", key: "licenseType" },
          { value: 1, label: "Республиканское", key: "licenseType" },
          { value: 2, label: "Международное", key: "licenseType" },
        ],
      },
    },
  },
  inputsInspectionTechnicalConditionBases: {
    key: "inputsInspectionTechnicalConditionBases",
    caption: "Обследование технического состояния баз (сооружений)",
    inputsOptions: {
      ownerLeName: {
        key: "ownerLeName",
        label: "Наименование эксплуатанта",
        type: "text",
        placeholder: "Введите",
      },
      location: {
        key: "location",
        label: "Местонахождение базы",
        type: "text",
        placeholder: "Введите",
      },
      startDate: {
        key: "startDate",
        label: "Дата последнего обследования от",
        type: "date",
      },
      endDate: {
        key: "endDate",
        label: "Дата последнего обследования до",
        type: "date",
      },
      checkStatus: {
        key: "checkStatus",
        label: "Результат обследования",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [{ value: 0, label: "Все", key: "checkStatus" }],
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: null, label: "Все", key: "section" }],
      },
    },
  },
  inputsTransportAccidentsReport: {
    key: "inputsTransportAccidentsReport",
    caption: "Учет транспортных аварийных случаев с участием маломерных судов",
    inputsOptions: {
      ownerSurname: {
        key: "ownerSurname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      ownerName: {
        key: "ownerName",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      ownerMidname: {
        key: "ownerMidname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      boatRegNum: {
        key: "boatRegNum",
        label: "Регистрационный номер судна",
        type: "text",
        placeholder: "Введите",
      },
      incidentType: {
        key: "incidentType",
        label: "Вид транспортного аварийного случая",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 0, label: "Все", key: "incidentType" },
          { value: 1, label: "Авария", key: "incidentType" },
          { value: 2, label: "Инцидент", key: "incidentType" },
        ],
      },
      incidentPlace: {
        key: "incidentPlace",
        label: "Место транспортного аварийного случая",
        type: "text",
        placeholder: "Введите",
      },
      date1: {
        key: "date1",
        label: "Дата с",
        type: "date",
      },
      date2: {
        key: "date2",
        label: "Дата по",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [{ value: null, label: "Все", key: "section" }],
      },
      driverDrunk: {
        key: "driverDrunk",
        label: "Алкогольное опьянение судоводителя",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 0, label: "Все", key: "driverDrunk" },
          { value: true, label: "Да", key: "driverDrunk" },
          { value: false, label: "Нет", key: "driverDrunk" },
        ],
      },
      incidentStatus: {
        key: "incidentStatus",
        label: "Статус дела",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 4, label: "Все", key: "incidentStatus" },
          { value: 2, label: "Сформировано", key: "incidentStatus" },
          { value: 1, label: "Новое", key: "incidentStatus" },
          { value: 3, label: "Прекращено", key: "incidentStatus" },
        ],
      },
    },
  },
  inputsSmallBoatRegistration: {
    key: "inputsSmallBoatRegistration",
    caption: "Регистрация маломерных судов",
    inputsOptions: {
      ...commonInputs,
      appNum,
      unp,
      nameLe,
      section,
      status: {
        ...status,
        options: [
          { value: 0, label: "Все", key: "status" },
          { value: 3, label: "К выдаче", key: "status" },
          { value: 1, label: "Зарегистрировано", key: "status" },
          { value: 2, label: "Отказано", key: "status" },
        ],
      },
    },
  },
  inputsTechnicalExamination: {
    key: "inputsTechnicalExamination",
    caption: "Техническое освидетельствование",
    inputsOptions: {
      ownerSurname: {
        key: "ownerSurname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      appNum: {
        key: "appNum",
        label: "Регистрационный номер заявления",
        type: "text",
        placeholder: "Введите",
      },
      ownerName: {
        key: "ownerName",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      leUnp: {
        key: "leUnp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      ownerMidname: {
        key: "ownerMidname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      leName: {
        key: "leName",
        label: "Наименование организации",
        type: "text",
        placeholder: "Введите",
      },
      section,
      status: {
        ...status,
        options: [
          { value: 0, label: "Все", key: "status" },
          { value: 5, label: "МС Годное", key: "status" },
          { value: 6, label: "МС Негодное", key: "status" },
          { value: 7, label: "Устранение замечаний", key: "status" },
          { value: 2, label: "Отказано", key: "status" },
        ],
      },
    },
  },
  inputsFormSearchBoatCardTechAndInfoChange: {
    key: "inputsFormSearchBoatCardTechAndInfoChange",
    caption: "Поиск маломерного судна для подачи заявления",
    gridKey: "-tech",
    inputsOptions: {
      ownerSurname: {
        key: "ownerSurname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      ownerName: {
        key: "ownerName",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      leUnp: {
        key: "leUnp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      ownerMidname: {
        key: "ownerMidname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      regNum,
      leName: {
        key: "leName",
        label: "Наименование организации",
        type: "text",
        placeholder: "Введите",
      },
      boatVin: {
        key: "boatVin",
        label: "Заводской номер судна",
        type: "text",
        placeholder: "Цифры и латиница",
      },
      engvin: {
        key: "engvin",
        label: "Заводской номер двигателя",
        type: "text",
        placeholder: "Цифры и латиница",
      },
    },
  },
  inputsFormSearchBoatCardDupshipsticket: {
    key: "inputsFormSearchBoatCardDupshipsticket",
    caption: "Поиск маломерного судна для подачи заявления",
    gridKey: "-dupl",
    inputsOptions: {
      ownerSurname: {
        key: "ownerSurname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      ownerName: {
        key: "ownerName",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      ownerMidname: {
        key: "ownerMidname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      regNum: {
        key: "regNum",
        label: "Регистрационный номер судна",
        type: "text",
        placeholder: "В формате XX1111",
      },
      boatVin: {
        key: "boatVin",
        label: "Заводской номер судна",
        type: "text",
        placeholder: "Цифры и латиница",
      },
      engvin: {
        key: "engvin",
        label: "Заводской номер двигателя",
        type: "text",
        placeholder: "Цифры и латиница",
      },
    },
  },
  inputsDuplicateShipsTicket: {
    key: "inputsDuplicateShipsTicket",
    caption: "Выдача дубликата судового билета",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      persNum: {
        key: "persNum",
        label: "Идентификационный номер заявителя",
        type: "text",
        placeholder: "Введите",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "status" },
          // { value: 3, label: "К выдаче", key: "status" },
          { value: 8, label: "Выдан", key: "status" },
          { value: 2, label: "Отказано", key: "status" },
          { value: 1, label: "Зарегистрировано", key: "status" },
        ],
      },
    },
  },
  inputsRegistrationInfoChange: {
    key: "inputsRegistrationInfoChange",
    caption: "Регистрация изменений сведений / заявления",
    inputsOptions: {
      ...commonInputs,
      regNum,
      unp,
      nameLe,
      section,
      status: {
        ...status,
        options: [
          { value: 0, label: "Все", key: "status" },
          { value: 1, label: "Зарегистрировано", key: "status" },
          { value: 2, label: "Отказано", key: "status" },
          { value: 3, label: "К выдаче", key: "status" },
          { value: 4, label: "АП завершена", key: "status" },
        ],
      },
    },
  },
  inputsShipsTicket: {
    key: "inputsShipsTicket",
    caption: "Выдача судового билета",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      regNum: {
        key: "regNum",
        label: "Регистрационный номер судна",
        type: "text",
        placeholder: "В формате XX1111",
      },
      unp: {
        key: "unp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      nameLe: {
        key: "nameLe",
        label: "Наименование организации",
        type: "text",
        placeholder: "Введите",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      status: {
        key: "status",
        label: "Статус заявления",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "status" },
          { value: 3, label: "К выдаче", key: "status" },
          { value: 8, label: "Выдан", key: "status" },
        ],
      },
    },
  },
  inputsProvisionInformation: {
    key: "inputsProvisionInformation",
    caption: "Предоставление информации о судне",
    inputsOptions: {
      ...commonInputs,
      appNum,
      unp,
      nameLe,
      section,
      status: {
        ...status,
        options: [
          { value: 0, label: "Все", key: "status" },
          { value: 1, label: "Зарегистрировано", key: "status" },
          { value: 4, label: "АП Завершена", key: "status" },
        ],
      },
    },
  },
  inputsLogbookAdministrativeProcedures: {
    key: "inputsLogbookAdministrativeProcedures",
    caption: "Журнал регистрации административных процедур",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      apcode: {
        key: "apcode",
        label: "Наименование административной процедуры",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: null, label: "Все", key: "apcode" }],
      },
      leName: {
        key: "leName",
        label: "Наименование организации",
        type: "text",
        placeholder: "Введите",
      },
      leUnp: {
        key: "leUnp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      dateStart: {
        key: "dateStart",
        label: "Дата подачи с",
        type: "date",
      },
      dateEnd: {
        key: "dateEnd",
        label: "Дата подачи по",
        type: "date",
      },
    },
  },
  inputsApplicationForTraining: {
    key: "inputsApplicationForTraining",
    caption: "Заявление на прохождение обучения",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      programId: {
        key: "programId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "programId" }],
      },
    },
  },
  inputsListenerTracking: {
    key: "inputsListenerTracking",
    caption: "Учет слушателей",
    inputsOptions: {
      orderNum: {
        key: "orderNum",
        label: "Номер приказа",
        type: "text",
        placeholder: "Введите",
      },
      orderDate: {
        key: "orderDate",
        label: "Дата приказа",
        type: "date",
      },
      startDate: {
        key: "startDate",
        label: "Период обучения с",
        type: "date",
      },
      endDate: {
        key: "endDate",
        label: "Период обучения по",
        type: "date",
      },
    },
  },
  inputsSearchListener: {
    key: "inputsSearchListener",
    caption: "Поиск слушателей",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      startDate: {
        key: "startDate",
        label: "Период обучения с",
        type: "date",
      },
      endDate: {
        key: "endDate",
        label: "Период обучения по",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
    },
  },
  inputsRegisterOfTrainees: {
    key: "inputsRegisterOfTrainees",
    caption: "Журнал учета слушателей",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      persNum: {
        key: "persNum",
        label: "Идентификационный номер",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      dateStart: {
        key: "dateStart",
        label: "Дата подачи заявления с",
        type: "date",
      },
      dateEnd: {
        key: "dateEnd",
        label: "Дата подачи заявления по",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
    },
  },
  inputsSearchRecordTrainedUsers: {
    key: "inputsSearchRecordTrainedUsers",
    caption: "Учет граждан, прошедших обучение управлению судами не в ГИМС",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      trainingOrgsId: {
        key: "trainingOrgsId",
        label: "Организация, осуществившая обучение",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "trainingOrgsId" }],
      },
      trainingProgId: {
        key: "trainingProgId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "trainingProgId" }],
      },
      trainingDocumentsDateStart: {
        key: "trainingDocumentsDateStart",
        label: "Период обучения с",
        type: "date",
      },
      trainingDocumentsDateEnd: {
        key: "trainingDocumentsDateEnd",
        label: "Период обучения по",
        type: "date",
      },
    },
  },
  inputsRecordTrainedUsersLogbook: {
    key: "inputsRecordTrainedUsersLogbook",
    caption: "Журнал учета граждан, прошедших обучение управлению судами",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      trainingOrgsId: {
        key: "trainingOrgsId",
        label: "Организация, осуществившая обучение",
        type: "selectWithSearch",
        placeholder: "Выберите",
        options: [
          { value: 0, label: "Все", key: "trainingOrgsId" },
          { value: 1, label: "ГИМС", key: "trainingOrgsId" },
          {
            value: 2,
            label: "иное учреждение образования",
            key: "trainingOrgsId",
          },
        ],
      },
      trainingProgId: {
        key: "trainingProgId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "trainingProgId" }],
      },
      trainingDocumentsDateStart: {
        key: "trainingDocumentsDateStart",
        label: "Период обучения с",
        type: "date",
      },
      trainingDocumentsDateEnd: {
        key: "trainingDocumentsDateEnd",
        label: "Период обучения с",
        type: "date",
      },
    },
  },
  inputsAppKnowledgeVerification: {
    key: "inputsAppKnowledgeVerification",
    caption: "Заявление на проверку знаний",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      programId: {
        key: "programId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "programId" }],
      },
    },
  },
  inputsSearchKnoweledgeTestRecord: {
    key: "inputsSearchKnoweledgeTestRecord",
    caption: "Учет прохождения проверки знаний",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
      programId: {
        key: "programId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "programId" }],
      },
      e1PassName: {
        key: "e1PassName",
        label: "Отметка, теория",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "e1PassName" },
          { value: 1, label: "Зачтено", key: "e1PassName" },
          { value: 2, label: "Не зачтено", key: "e1PassName" },
        ],
      },
      e2PassName: {
        key: "e2PassName",
        label: "Отметка, практика",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "e2PassName" },
          { value: 3, label: "В процессе сдачи", key: "e2PassName" },
          { value: 1, label: "Зачтено", key: "e2PassName" },
          { value: 2, label: "Не зачтено", key: "e2PassName" },
        ],
      },
      checkPassName: {
        key: "checkPassName",
        label: "Результат проверки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "checkPassName" },
          { value: 1, label: "Зачтено", key: "checkPassName" },
          { value: 2, label: "Не зачтено", key: "checkPassName" },
        ],
      },
      protNum: {
        key: "protNum",
        label: "Номер протокола",
        type: "text",
        placeholder: "Введите",
      },
      protDate: {
        key: "protDate",
        label: "Дата протокола",
        type: "date",
      },
    },
  },
  inputsSearchPeopleForTest: {
    key: "inputsSearchPeopleForTest",
    caption: "Поиск проходящего проверку знаний",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      selfTraining: {
        key: "selfTraining",
        label: "Самоподготовка",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: false,
        options: [
          { value: 0, label: "Все", key: "selfTraining" },
          { value: 1, label: "Да", key: "selfTraining" },
          { value: 2, label: "Нет", key: "selfTraining" },
        ],
      },
    },
  },
  inputsSettlements: {
    key: "inputsSettlements",
    caption: "Наименования населенных пунктов",
    inputsOptions: {
      oblast: {
        key: "oblast",
        label: "Область",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [],
      },
      rayon: {
        key: "rayon",
        label: "Район",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [],
      },
      nameRu: {
        key: "nameRu",
        label: "Населенный пункт",
        type: "text",
        placeholder: "Введите",
      },
    },
  },
  inputsApplicationSearch: {
    key: "inputsApplicationSearch",
    caption: "Поиск заявителя для выдачи удостоверения",
    inputsOptions: {
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
      },
      birthDate: {
        key: "birthDate",
        label: "Дата рождения",
        type: "date",
      },
      programId: {
        key: "programId",
        label: "Программа подготовки",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "programId" }],
      },
      section: {
        key: "section",
        label: "Участок",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "section" }],
      },
    },
  },
  inputsCountries: {
    key: "inputsCountries",
    caption: "Страны",
    inputsOptions: {
      countryFullname: {
        key: "countryFullname",
        label: "Полное наименование",
        type: "text",
        placeholder: "Введите",
      },
      countryName: {
        key: "countryName",
        label: "Краткое наименование",
        type: "text",
        placeholder: "Введите",
      },
    },
  },
  inputsOrganizations: {
    key: "inputsOrganizations",
    caption:
      "Организации и индивидуальные предприниматели, осуществляющие обучение управлению моторными судами",
    inputsOptions: {
      name: {
        key: "name",
        label: "Полное наименование",
        type: "text",
        placeholder: "Введите",
      },
      shortName: {
        key: "shortName",
        label: "Краткое наименование",
        type: "text",
        placeholder: "Введите",
      },
    },
  },
  inputsSections: {
    key: "inputsSections",
    caption: "Участки ГИМС",
    inputsOptions: {
      section: {
        key: "sctId",
        label: "Наименование участка",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "sctId" }],
      },
      depId: {
        key: "depId",
        label: "Наименование структурного подразделения",
        type: "selectWithSearch",
        placeholder: "Выберите",
        isSearchable: true,
        options: [{ value: 0, label: "Все", key: "depId" }],
      },
    },
  },
};

export function setOptionsSections(lib, key) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions.section.options.length === 1) {
        item.inputsOptions.section.options.push(...lib);
      }
    }
  });
}
export function setOptionsDepartments(lib, key) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions.depId.options.length === 1) {
        item.inputsOptions.depId.options.push(...lib);
      }
    }
  });
}

export function setOptionsNsiAp(lib, key) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions.apcode.options.length === 1) {
        item.inputsOptions.apcode.options.push(...lib);
      }
    }
  });
}

export function setOptionsProgramId(lib, key, optionKey) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions[optionKey].options.length === 1) {
        item.inputsOptions[optionKey].options.push(...lib);
      }
    }
  });
}

export function setOptionsTrainingOrgsId(lib, key, optionKey) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions[optionKey].options.length === 1) {
        item.inputsOptions[optionKey].options.push(...lib);
      }
    }
  });
}

export function setOptionsStatus(lib, key) {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions.status.options.length === 1) {
        item.inputsOptions.status.options.push(...lib);
      }
    }
  });
}

export const setOptionsForInputsNsiStatusRHF = (lib, key) => {
  Object.values(options).map((item) => {
    if (item.key === key) {
      if (item.inputsOptions.checkStatus.options.length === 1) {
        item.inputsOptions.checkStatus.options.push(...lib);
      }
    }
  });
};

export const setOblast = (inputs) => {
  Object.values(options).map((item) => {
    if (item.key === "inputsSettlements") {
      if (item.inputsOptions.oblast.options.length === 0) {
        item.inputsOptions.oblast.options.push(...inputs);
      }
    }
  });
};

export const getRayonByOblId = async (id) => {
  const getData = async (idF) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_GET_DICTIONARY_RAYON_FOR_OBL + idF);

    const data = await response.json();

    return data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
        key: "rayon",
      };
    });
  };

  const finalData = await getData(id);

  Object.values(options).map((item) => {
    if (item.key === "inputsSettlements") {
      item.inputsOptions.rayon.options = [...finalData];
    }
  });
  return options.inputsSettlements;
};
